import React from 'react'
import Skeleton from 'react-loading-skeleton'

export default function NewAcademyCardLoading() {
  return (
    <div className='w-full flex flex-col'>
        <Skeleton className='block w-full rounded-xl h-80' />
        <Skeleton className='block w-full rounded-xl h-6 -mt-2' />

    </div>
  )
}
